import { ICoords } from "../../../../@types/GoogleMaps/ICoord";
import { IMicroAreas } from "../../../../@types/API/IMicroArea";
import { IOptionProps, IOptionsProps } from "../../../../@types/reactSelect/IOption";

export const MIN_DETACHED_TASK_DETAILS_LENGTH = 8;

export type StandardPastureTaskFiltersProps = {
  farmOptions: IOptionsProps;
  currentFarm: IOptionProps | undefined;
  onFarmChange: (farmId: unknown) => void;
  farmLabel: string;
  areaOptions: IOptionsProps;
  currentArea: IOptionProps | undefined;
  onAreaChange: (areaId: unknown) => void;
  areaLabel: string;
  responsibleOptions: IOptionsProps;
  currentResponsible: IOptionProps | undefined;
  onResponsibleChange: (option: IOptionProps | null) => void;
  microAreaOptions: IOptionsProps;
  currentMicroArea: IOptionProps | undefined;
  onMicroAreaChange: (microAreaId: unknown) => void;
  fitCoords: ICoords;
  drawCoords: ICoords | undefined;
  allMicroAreas: IMicroAreas | undefined;
  farmOutlineCoords: ICoords | undefined;
  onMapMicroAreaSelected: (e: { id?: number; area_id?: number } | undefined) => void;
};

export type DetachedTaskFiltersProps = {
  farmOptions: IOptionsProps;
  currentFarm: IOptionProps | undefined;
  onFarmChange: (farmId: unknown) => void;
  farmLabel: string;
  allResponsibles: IOptionsProps;
  currentResponsible: IOptionProps | undefined;
  onResponsibleChange: (option: IOptionProps | null) => void;
  taskDetails: string;
  onTaskDetailsChange: (value: string) => void;
};

export type ProductIncomingTaskFiltersProps = {
  farmOptions: IOptionsProps;
  currentFarm: IOptionProps | undefined;
  onFarmChange: (farmId: unknown) => void;
  farmLabel: string;
  allResponsibles: IOptionsProps;
  currentResponsible: IOptionProps | undefined;
  onResponsibleChange: (option: IOptionProps | null) => void;
};
